import { orgsRequest } from './request';

const GET_PAYABLE_ORG_NODE_QUERY = `
query OrgPayable($campaignId: ID!) {
  orgPayable(campaignId: $campaignId) {
    id
  }
}
`;

export const orgPayable = async (
  campaignId: string,
): Promise<string | undefined> => {
  const orgNodeRes = await orgsRequest(GET_PAYABLE_ORG_NODE_QUERY, {
    campaignId,
  });
  const orgNodeResJson = await orgNodeRes.json();
  if (
    orgNodeResJson.data.orgPayable &&
    orgNodeResJson.data.orgPayable.length > 0
  ) {
    return orgNodeResJson.data.orgPayable[0]?.id;
  }
  throw new Error('orgPayable not found');
};
